import { fulfillmentFirestoreId } from "features/purchases/useShippingStatus";

import type {
  LegacyPortalShippingStatus,
  LegacyPortalShippingStatusDispatchStatus,
} from "@spwn-portal/grpc";

/**
 * 注文に紐づく配送の発送状況を集める。
 * 配送IDの形式が不正なもの、配送状況が未取得のものは除く
 */
export const getDispatchStatuses = (
  fulfillmentFirestoreIds: string[],
  shippingStatusesMap: Map<string, LegacyPortalShippingStatus>
): LegacyPortalShippingStatusDispatchStatus[] =>
  fulfillmentFirestoreIds.reduce<LegacyPortalShippingStatusDispatchStatus[]>(
    (dispatchStatuses, id) => {
      const parseResult = fulfillmentFirestoreId.safeParse(id);
      if (!parseResult.success) return dispatchStatuses;
      const shippingStatus = shippingStatusesMap.get(parseResult.data);
      if (shippingStatus?.status !== undefined) {
        dispatchStatuses.push(shippingStatus.status);
      }
      return dispatchStatuses;
    },
    []
  );
